import {AbstractStore} from "./AbstractStore";
import {AppCtx} from "../ioc/ApplicationContext";
import {DashboardUser, GroupPermission} from "../../generated/protocol";

export interface UserStoreState {
    user?: DashboardUser;
    status?: UserStatus;
    displayRequestForbidden?: boolean;
    activeRole?: string;
    activeOperator?: number;
    permissions?: { [key: string]: GroupPermission };
}

export enum UserStatus {
    LOGGED_OUT,
    LOGGED_IN,
    LOGIN_ERROR
}

export class UserStore extends AbstractStore<UserStoreState> {
    static readonly DEFAULT_OPERATOR_ID = 10;

    user: DashboardUser;
    permissions: { [key: string]: GroupPermission };
    status: UserStatus = UserStatus.LOGGED_OUT;
    displayRequestForbidden: boolean;
    activeRole: string;
    activeOperator: number = UserStore.DEFAULT_OPERATOR_ID;

    constructor() {
        super();
        let userActions = AppCtx.getUserActions();
        this.user = null;
        this.bindListeners({
            handleLoginSuccess: userActions.loginSuccess,
            handleLoginError: userActions.loginFailed,
            handleNotLoggedIn: userActions.notLoggedIn,
            handleForbiddenRequest: userActions.requestForbidden,
            handleResetForbiddenStatus: userActions.resetForbiddenStatus,
            handleChangeOperator: userActions.changeOperator
        });
    }

    handleLoginSuccess(wrapper: { user: DashboardUser, permissions: { [key: string]: GroupPermission } }) {
        this.status = UserStatus.LOGGED_IN;
        this.user = wrapper.user;
        this.activeRole = wrapper.user.role;
        this.permissions = wrapper.permissions;
    }

    handleForbiddenRequest() {
        this.displayRequestForbidden = true;
    }

    handleResetForbiddenStatus() {
        this.displayRequestForbidden = false;
    }

    handleLoginError() {
        this.status = UserStatus.LOGIN_ERROR;
    }

    handleNotLoggedIn() {
        this.status = UserStatus.LOGGED_OUT;
        this.user = null;
        this.permissions = null;
    }

    handleChangeOperator(operator: number) {
        if (operator == -1) {
            this.activeRole = this.user.role;
            this.activeOperator = UserStore.DEFAULT_OPERATOR_ID;
        } else {
            this.activeRole = this.user.role;
            this.activeOperator = operator;
        }
    }


}




// WEBPACK FOOTER //
// ./src/app/store/UserStore.ts